import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.black,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 77
  const h = 77
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.50003 67.5829C1.50321 66.2686 1.80425 64.9845 2.36588 63.8591L33.1659 4.50703C33.1662 4.50638 33.1665 4.50573 33.1669 4.50508C33.7416 3.41226 34.5413 2.52598 35.4763 1.9184C36.4102 1.31147 37.4511 1 38.5 1C39.5489 1 40.5898 1.31147 41.5237 1.9184C42.4585 2.52588 43.2582 3.41196 43.8328 4.50453C43.8333 4.50536 43.8337 4.5062 43.8341 4.50703L74.6309 63.8526C74.632 63.8549 74.6331 63.8571 74.6342 63.8594C75.1958 64.9846 75.4968 66.2687 75.5 67.5829C75.5032 68.8997 75.2072 70.1884 74.6488 71.3192C74.0906 72.4498 73.2943 73.3741 72.353 74.0134C71.4152 74.6504 70.3629 74.9852 69.2995 75H7.70053C6.63714 74.9852 5.58483 74.6504 4.647 74.0134C3.70572 73.3741 2.90944 72.4498 2.35117 71.3192C1.79277 70.1884 1.49683 68.8997 1.50003 67.5829Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9492 26.1016L38.9492 53.1016"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9492 59.2031H38.9856"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
